import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Wrench, BookOpen, Code, FileText, Crown } from "lucide-react";

export default function FeaturesOverview() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const features = [
    {
      id: 'tools',
      icon: Wrench,
      title: 'Herramientas IA',
      description: 'Accede a las mejores herramientas de IA como HuggingFace Spaces, modelos pre-entrenados y APIs.',
      buttonText: 'Explorar herramientas →',
      buttonColor: 'text-blue-600',
      gradient: 'from-blue-600 to-purple-600',
      isPremium: true,
    },
    {
      id: 'blog',
      icon: BookOpen,
      title: 'Blog IA',
      description: 'Mantente actualizado con las últimas tendencias, noticias y avances en inteligencia artificial.',
      buttonText: 'Leer artículos →',
      buttonColor: 'text-emerald-600',
      gradient: 'from-emerald-500 to-teal-500',
      isPremium: false,
    },
    {
      id: 'notebooks',
      icon: Code,
      title: 'Notebooks',
      description: 'Implementa y experimenta con código IA en nuestro entorno de notebooks interactivo.',
      buttonText: 'Abrir notebook →',
      buttonColor: 'text-orange-600',
      gradient: 'from-orange-500 to-red-500',
      isPremium: true,
    },
    {
      id: 'papers',
      icon: FileText,
      title: 'Papers Científicos',
      description: 'Accede a los últimos papers y investigaciones científicas en inteligencia artificial.',
      buttonText: 'Ver papers →',
      buttonColor: 'text-purple-600',
      gradient: 'from-purple-500 to-pink-500',
      isPremium: false,
    },
  ];

  return (
    <section id="features" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">Todo lo que necesitas para IA</h3>
          <p className="text-lg text-gray-600">Cuatro secciones especializadas para tu crecimiento en inteligencia artificial</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) => {
            const IconComponent = feature.icon;
            return (
              <Card key={feature.id} className="relative bg-white shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
                {feature.isPremium && (
                  <div className="absolute top-4 right-4">
                    <span className="bg-amber-400 text-white text-xs px-2 py-1 rounded-full font-medium flex items-center">
                      <Crown className="w-3 h-3 mr-1" />
                      Premium
                    </span>
                  </div>
                )}
                <CardContent className="pt-6">
                  <div className={`w-12 h-12 bg-gradient-to-r ${feature.gradient} rounded-lg flex items-center justify-center mb-4`}>
                    <IconComponent className="text-white text-lg" />
                  </div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h4>
                  <p className="text-gray-600 mb-4">{feature.description}</p>
                  <Button
                    variant="ghost"
                    onClick={() => scrollToSection(feature.id)}
                    className={`${feature.buttonColor} font-medium hover:underline p-0 h-auto`}
                  >
                    {feature.buttonText}
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
